const cache = new WeakMap();
export function createDateTimeFormat(options = {}) {
    let cachedFormat;
    if ((cachedFormat = cache.get(options))) {
        return cachedFormat;
    }
    const { locale = 'en-GB' } = options;
    const format = new Intl.DateTimeFormat(locale, options);
    cache.set(options, format);
    return format;
}
export function createFormatDate(options) {
    const format = createDateTimeFormat(options);
    return (date) => format.format(date);
}
export function createFormatDateToParts(options) {
    const format = createDateTimeFormat(options);
    return (date) => format.formatToParts(date);
}
//# sourceMappingURL=createDateTimeFormatter.js.map